"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Acl = exports.roleTypes = exports.permissionTypes = void 0;
const acl_1 = require("./acl");
const roleUtils_1 = __importDefault(require("./roleUtils"));
var permissions_1 = require("./permissions");
Object.defineProperty(exports, "permissionTypes", { enumerable: true, get: function () { return __importDefault(permissions_1).default; } });
var roles_1 = require("./roles");
Object.defineProperty(exports, "roleTypes", { enumerable: true, get: function () { return __importDefault(roles_1).default; } });
/**
 * Legacy Authorization checks, do not create any new logic with this.
 * @deprecated Role checks should be converted into new permissions, and permission checks should be migrated to the new format.
 * @example
 * // e.g. checkRole(userRoles, roleTypes.SUPER_ADMIN) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Permission Checks should be migrated to the new functions:
 * // Use usePermissionCheck() react hook or HasPermission() HOC in the frontend, or ctx.authorization.requesterHasPermission (bool) ctx.authorization.validateRequesterPermissions (throws) or  in the backend.
 * // e.g. checkPermission(loginUser.permissions, permissionTypes.GRADE_VIEW_OWN) or authorization.requesterHasLegacyPermissions(requester, [permissionTypes.GRADE_VIEW_OWN]) should become:
 * // Frontend:
 * const { isPermitted, loading } = usePermissionCheck({
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * export default withPermission(MyComponent);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 */
exports.Acl = {
    ...roleUtils_1.default,
    checkRole: acl_1.checkRole,
    checkPermission: acl_1.checkPermission,
};
exports.default = exports.Acl;
//# sourceMappingURL=index.js.map